import * as types from 'stores/types';

export function toggleLoading( isLoading ) {
  return { type: types.TOGGLE_LOADING, isLoading };
}

export function toggleAlertError( message, msgToCopy ) {
  return { type: types.TOGGLE_ALERT_ERROR, message, msgToCopy };
}

export function switchLanguage( locale ) {
  return { type: types.SWITCH_LANGUAGE, locale };
}

export function updateApiStatus( data ) {
  return { type: types.UPDATE_API_STATUS, data };
}

export function updateSettings( data ) {
  return { type: types.UPDATE_SETTINGS, data };
}



// WEBPACK FOOTER //
// ./stores/actions/common/settings.js